import { AxiosError } from 'axios';
import { http } from '../http';

export interface Carro {
  objCota: any;
  objCombustivel: any;
  objCor: any;
  objTipoVeiculo: any;
  objCategoria: any;
  cooperativaObj: any;
  objVeiculo: any;
  id?: string;
  codigoVeiculo: string;
  codigo_voluntario: string;
  anoFabricacao: number;
  anoModelo: number;
  chassi: string;
  placa: string;
  modelo: string;
  renavam: string;
  marca?: string;
  codigoFipe: string;
  corId?: string;
  corNome?: string;
  combustivel: string;
  cambio: string;
  cota: string;
  cor: string;
  tipoVeiculo: string;
  categoria: string;
  cooperativa: string;
  cotaId?: string;
  cotaDescricao?: string;
  vencimentoDesejado: string;
  valorFipe: string;
  valorProtegido: string;
  valorAdesao: string;
  cep?: string;
  rua?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
}

interface RateioResponse {
  id: string;
  valor_rateio_medio: number;
}

interface UpdateCarroResponse {
  mensagem: string;
  carro: {
    id: string;
    placa?: string;
    modelo?: string;
    anoModelo?: number;
    cor?: string;
    combustivel?: string;
    [key: string]: any;
  };
  /**
   * at-54 (item 52): só vem quando o valor de adesão MUDOU num veículo que já está no
   * SGA — nesse caso o backend reenvia o cadastro para lá.
   *
   * `NAO_APLICAVEL` é sucesso, não pendência: o veículo ainda não subiu, e o cadastro
   * pendente já vai levar o valor novo. Só `PENDENTE` merece aviso na tela.
   */
  envioSga?: {
    status: 'ENVIADO' | 'PENDENTE' | 'NAO_APLICAVEL';
    detalhe?: string;
  };
}

export const fetchCarroPorId = async (id: string): Promise<Carro> => {
  try {
    const response = await http.get(`/carro/buscar/${id}`);

    return response.data;
  } catch (error: unknown) {
    const axiosError = error as AxiosError;
    throw axiosError;
  }
};

export const fetchCarroPorPlaca = async (placa: string): Promise<Carro> => {
  try {
    const response = await http.get(`/carro/buscar/placa/${placa}`);

    return response.data;
  } catch (error: unknown) {
    const axiosError = error as AxiosError;
    throw axiosError;
  }
};

export const buscarRateioPorId = async (carroId: string): Promise<RateioResponse> => {
  try {
    const response = await http.get(`/carro/rateio/${carroId}`);

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erro ao buscar o rateio médio do veículo");
  }
};

export interface ResultadoEmplacamento {
  mensagem: string;
  /** Desfecho do reenvio ao SGA — mesmo vocabulário do envio imediato (at-36). */
  envioSga: { status: 'ENVIADO' | 'PENDENTE' | 'NAO_APLICAVEL' | string; detalhe?: string };
}

/**
 * Informa a placa de um veículo 0km (at-81). LANÇA com a mensagem do backend:
 * placa inválida (400), outra carteira (403) e placa já usada (409) precisam
 * chegar ao consultor por extenso.
 */
export const emplacarVeiculo = async (
  carroId: string,
  dados: { placa: string; renavam?: string },
): Promise<ResultadoEmplacamento> => {
  try {
    const response = await http.patch(`/carro/${carroId}/emplacar`, dados);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Não foi possível registrar a placa.');
  }
};

export const atualizarVeiculo = async (carroId: string, updateData: any): Promise<UpdateCarroResponse> => {
  try {
    const response = await http.patch(`/carro/atualizar/${carroId}`, updateData);

    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erro ao atualizar veículo");
  }
};
